import styled from 'styled-components'
import { P, H1 } from './Typography'
import { Spacer } from './Spacer'
import { Button } from './Button'
import UpArrow from '../assets/images/upArrow.png'
import art from '../assets/images/art1.png'
import rocket from '../assets/images/rocket.png'
import React, { useState } from 'react'
import ModalView from './ModalView'
import { ethers } from 'ethers'
import abi from '../contract.json'

const CONTRACT_ADDRESS = '0x716ad8b7071Dbf033D4f8f09f448bBbc7b18a9EF'
const MINT_TIME = new Date(1694116800000)
const DATE_STRING =
  MINT_TIME.getDate() +
  '/' +
  (MINT_TIME.getMonth() + 1) +
  '/' +
  MINT_TIME.getFullYear() +
  ' ' +
  (MINT_TIME.getUTCHours() - 4) +
  ':00:00 EST'

const Wrapper = styled.div``

const Input = styled.input`
  height: ${(props) => (props.height ? props.height : '50px')};
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  border: 1px solid grey;
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : '3px'};
  padding: 15px;
  margin: ${(props) => (props.margin ? props.margin : '10px')};
  color: white;
  margin-left: ${(props) => (props.fright ? 'auto' : 'initial')};
  margin-right: ${(props) => (props.fleft ? 'auto' : 'initial')};
  @media (max-width: 768px) {
    width: 100%;
  }
`

export default function HeroSection({ sectionRef }) {
  const [open, setOpen] = useState(false)
  const [amount, setAmount] = useState(0)
  const [prefetched, setPrefetched] = useState('')

  const handleClose = () => {
    setOpen(false)
  }

  const connectWallet = async () => {
    try {
      const provider = new ethers.BrowserProvider(window.ethereum)
      await provider.send('eth_requestAccounts', [])
      setOpen(true)
    } catch (error) {}
  }

  async function mintNFTs() {
    const provider = new ethers.BrowserProvider(window.ethereum)
    await provider.send('eth_requestAccounts', [])
    const signer = await provider.getSigner()
    const contract = new ethers.Contract(CONTRACT_ADDRESS, abi, signer)

    let value = ethers.parseEther((0 * amount).toString())
    let quantity = amount

    try {
      setPrefetched('MINTING')
      const tx = await contract.mint(quantity, {
        value: value,
      })
      await tx.wait()
      window.location.reload()
    } catch (error) {
      setPrefetched('ERRORED')
      console.log(error)
    }
  }

  return (
    <>
      <ModalView
        width={'500px'}
        height={'auto'}
        show={open}
        setshow={setOpen}
        onClose={handleClose}
        title="Mint Nfts"
      >
        <Input
          type="number"
          value={amount}
          min={0}
          onChange={(e) => {
            setAmount(parseInt(e.target.value))
          }}
          disabled={prefetched !== ''}
          placeholder="Enter Amount of NFTs"
        />
        <div className="d-flex w-100 justify-content-center">
          <Button onClick={mintNFTs}>Mint</Button>
        </div>
      </ModalView>

      <Wrapper>
        <Spacer height={'80px'} />
        <div className="text-center">
          <div style={{ position: 'relative' }}>
            <H1 fontSize="150px">The Syndicatz</H1>
            <Spacer height={'35px'} />
          </div>
          <Spacer height={'35px'} />

          <div className="d-flex w-100 justify-content-center">
            {Date.now() >= MINT_TIME ? (
              <Button
                onClick={() => {
                  connectWallet()
                }}
              >
                <div>Mint now</div>
                <img style={{ marginLeft: '10px' }} src={UpArrow} alt="" />
              </Button>
            ) : (
              <p style={{ color: 'white' }}>Mint starting at {DATE_STRING}</p>
            )}
          </div>
          <Spacer height={'200px'} />
        </div>
      </Wrapper>
    </>
  )
}
